import React from 'react';
import { Tabs } from 'antd';
import { isExternalContributorOrExternalView } from '../../utils/UserInfo';
import { projectStatusMap } from '../../components/ProjectStatusMap';

const TabPane = Tabs.TabPane;
const padfix = {
  // margin: '16px 16px 5px 16px',
  margin: '16px 16px 5px',
  border: '1px solid #f0f0f0',
};

const navMenuHeaderStyle = {
  style1 : { 
  padding: '12px', 
  backgroundColor: '#0CA0DA', 
  color: 'rgb(255, 255, 255)'
  },
  style0: {
      padding: '12px', 
      backgroundColor: '#f0f0f0'
  }
}

function FMPTrackerTabs({
  parsedFilterSelectionsJson,
  history,
  match,
  setActiveTabKeyOnChange,
  activeTabKey,
}) {
  return (
    <>
    
      <Tabs
        centered
        defaultActiveKey={
          isExternalContributorOrExternalView()
            ? 'active'
            : parsedFilterSelectionsJson &&
              parsedFilterSelectionsJson.selectedDefaultDashView
            ? projectStatusMap[
                parsedFilterSelectionsJson.selectedDefaultDashView
              ]
            : parsedFilterSelectionsJson &&
              !parsedFilterSelectionsJson.selectedDefaultDashView
            ? 'all'
            : 'upcoming'
        }
        //  defaultActiveKey={(isExternalContributorOrExternalView() ? "active" : 'upcoming')}
        onTabClick={(key) => {
          setActiveTabKeyOnChange(key)
          history.push({
            pathname: `/dashboard/${key}`,
            state: {
              station: '',
              status: '',
              activeTabKey: key,
            },
          })
        }
        }
        activeKey={
          match.params.tabId ||
          (isExternalContributorOrExternalView() ? 'active' : activeTabKey)
        }
        tabBarGutter={50}
        tabBarStyle={padfix}
        tabBarExtraContent={{left: <div className={'TabPaneTitle'} style={activeTabKey.startsWith('fmptracker_')?navMenuHeaderStyle.style1: navMenuHeaderStyle.style0}>&nbsp;&nbsp;&nbsp;FMP Tracker&nbsp;&nbsp;&nbsp;</div>}}
      >
 {
          <TabPane
            tab={<div className={'TabPaneTitle'}>All</div>}
            key='fmptracker_all'
          />
        }


        {
          <TabPane
            tab={<div className={'TabPaneTitle'}>Pending</div>}
            key='fmptracker_pending'
          />
        }
        {
          <TabPane
            tab={<div className={'TabPaneTitle'}>In Progress</div>}
            key='fmptracker_progress'
          />
        }
         {
          <TabPane
            tab={<div className={'TabPaneTitle'}>Under Review</div>}
            key='fmptracker_review'
          />
        }
         {
          <TabPane
            tab={<div className={'TabPaneTitle'}>As-Builts</div>}
            key='fmptracker_asbuilts'
          />
        }
        {
          <TabPane
            tab={<div className={'TabPaneTitle'}>Complete</div>}
            key='fmptracker_complete'
          />
        }  
      </Tabs>
    </>
  );
}

export default FMPTrackerTabs;